// Pure helper for previewing pasted spreadsheet data in the Activity Import
// "Add Data" step. It mirrors the server-side auto-detection (tab, then
// semicolon, then comma) closely enough to show a live row/column count and to
// decide whether the paste is "recognizable" -- the authoritative parse still
// happens server-side (Activities::Imports::TabularParser). CommonJS so it can
// be unit-tested with `node --test`.

const CANDIDATES = ['\t', ';', ','];

function splitLines(text) {
  return String(text == null ? '' : text)
    .split(/\r\n?|\n/)
    .filter((line) => line.trim() !== '');
}

// Detect the delimiter from the first non-empty line, preferring tab, then
// semicolon, then comma; defaults to comma when none are present.
function detectSeparator(text) {
  const lines = splitLines(text);
  const line = lines.length ? lines[0] : '';
  let best = ',';
  let bestCount = 0;
  for (const candidate of CANDIDATES) {
    const count = line.split(candidate).length - 1;
    if (count > bestCount) {
      best = candidate;
      bestCount = count;
    }
  }
  return best;
}

// Returns { separator, columnCount, rowCount, totalLines } for recognizable
// tabular data (a header line with at least one non-blank cell), else null.
// rowCount excludes the header row.
function preview(text) {
  const lines = splitLines(text);
  if (lines.length === 0) return null;

  const separator = detectSeparator(text);
  const headerCells = lines[0].split(separator).map((cell) => cell.trim());
  if (!headerCells.some((cell) => cell !== '')) return null;

  return {
    separator,
    columnCount: headerCells.length,
    rowCount: Math.max(lines.length - 1, 0),
    totalLines: lines.length,
  };
}

module.exports = { detectSeparator, preview };
